import * as React from 'react';

import { Container } from '../../../../components/Container';
import { FieldTitle } from '../../../../components/FieldTitle';
import { SIZE_0, SIZE_20, SIZE_28, SIZE_WIDE } from '../../../../constants/sizes';

interface IRenderFieldRowProps {
  title: string;
  field: React.ReactNode;
  dataTestId?: string;
}

export const renderFieldRow = ({ title, field, dataTestId }: IRenderFieldRowProps): React.ReactNode => (
  <Container padding={`${SIZE_20} ${SIZE_28} ${SIZE_0}`} display="flex" columnGap="40px" data-testid={dataTestId}>
    <FieldTitle>{title}</FieldTitle>
    <Container width={SIZE_WIDE}>{field}</Container>
  </Container>
);
